import { useEffect, useState } from "react";

export const EjercicioByRange = ({ name, value, onChange, extrayear = 0,startYear=2024 }) => {
  const [state, setState] = useState([]);
  const cargarArray = (data, year) => {
    data = [...data, year];
    if (Number(year) < new Date().getFullYear() + extrayear) {
      return cargarArray(data, Number(year) + 1);
    }
    return data;
  };
  useEffect(() => {
    setState(cargarArray([], startYear));
  }, [name]);

  if (state.length == 0) return <div>No data</div>;
  return (
    <select
      className="select-ejercicio"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="0">Seleccionar...</option>
      {state.map((item) => (
        <option key={`ejercicio-${item}`} value={item}>
          {item}
        </option>
      ))}
    </select>
  );
};
